import { __rest, __assign } from 'tslib';
import * as React from 'react';
var UitkLayoutSpaceMap = [['half', 'gap-half'], ['one', 'gap-one'], ['two', 'gap-two'], ['three', 'gap-three'], ['four', 'gap-four'], ['six', 'gap-six'], ['twelve', 'gap-twelve']];
var UitkLayoutSpaces = new Map(UitkLayoutSpaceMap);
var UitkLayoutFixedSizeMap = [['zero', 'zero'], ['fifteen', 'fifteen'], ['sixteen', 'sixteen'], ['twenty_four', 'twenty_four'], ['seventy_two', 'seventy_two'], ['seventy_six', 'seventy_six'], ['eighty_eight', 'eighty_eight'], ['ninety_six', 'ninety_six'], ['one_hundred_four', 'one_hundred_four'], ['one_hundred_twelve', 'one_hundred_twelve'], ['one_hundred_twenty', 'one_hundred_twenty']];
var UitkLayoutFixedSizes = new Map(UitkLayoutFixedSizeMap);
var UitkLayoutPercentageSizeMap = [['full_width', 'full_width'], ['half_width', 'half_width'], ['third_width', 'third_width'], ['quarter_width', 'quarter_width']];
var UitkLayoutPercentageSizes = new Map(UitkLayoutPercentageSizeMap);
// To be deprecated
var UitkLayoutSizeMap = [['zero', 'zero'], ['fifteen', 'fifteen'], ['sixteen', 'sixteen'], ['twenty_four', 'twenty_four'], ['seventy_two', 'seventy_two'], ['seventy_six', 'seventy_six'], ['eighty_eight', 'eighty_eight'], ['ninety_six', 'ninety_six'], ['one_hundred_four', 'one_hundred_four'], ['one_hundred_twelve', 'one_hundred_twelve'], ['one_hundred_twenty', 'one_hundred_twenty'], ['full_width', 'full_width'], ['half_width', 'half_width'], ['third_width', 'third_width'], ['quarter_width', 'quarter_width']];
var UitkLayoutSizes = new Map(UitkLayoutSizeMap);
var UitkLayoutTagMap = [['article', 'article'], ['aside', 'aside'], ['div', 'div'], ['footer', 'footer'], ['header', 'header'], ['section', 'section'], ['ul', 'ul'], ['ol', 'ol'], ['li', 'li'], ['main', 'main']];
var UitkLayoutTags = new Map(UitkLayoutTagMap);
var UitkLayout = function (props) {
  var children = props.children,
    className = props.className,
    tag = props.tag,
    domRef = props.domRef,
    attributes = __rest(props, ["children", "className", "tag", "domRef"]);
  // Renders the custom Tag
  var Tag = tag && UitkLayoutTags.get(tag) || UitkLayoutTags.get('div');
  return children ? React.createElement(Tag, __assign({
    ref: domRef,
    className: className
  }, attributes), children) : null;
};
var UitkLayoutItem = function (props) {
  var className = props.className;
  var childrenArray = React.Children.toArray(props.children);
  if (!childrenArray.length) {
    return null;
  }
  var firstChild = childrenArray[0];
  var decoratedChild = React.cloneElement(firstChild, {
    className: className
  });
  return decoratedChild;
};
export { UitkLayout, UitkLayoutFixedSizes, UitkLayoutItem, UitkLayoutPercentageSizes, UitkLayoutSizes, UitkLayoutSpaces, UitkLayoutTags };